import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=c522d13e&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"
import style0 from "./vip.vue?vue&type=style&index=0&id=c522d13e&prod&lang=less&scoped=true"
import style1 from "./vip.vue?vue&type=style&index=1&id=c522d13e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522d13e",
  null
  
)

export default component.exports